import * as React from 'react'
import { ReactElement } from 'react'
import { Route } from 'react-router'
import { Switch } from 'react-router-dom'
import useModules from '../hooks/module/useModules'
import { ModuleType } from '../context/GlobalContext'
import InvoiceOverview from './Finance/Invoice/InvoiceOverview'
import AddInvoice from './Finance/Invoice/AddInvoice'
import EditInvoice from './Finance/Invoice/EditInvoice'

export default function Invoices(): ReactElement {
    const modules = useModules()

    return (
        <Switch>
            {modules.has(ModuleType.Invoices) && <Route exact path="/invoice" component={InvoiceOverview} />}
            {modules.has(ModuleType.Invoices) && <Route exact path="/invoice/add" component={AddInvoice} />}
            {modules.has(ModuleType.Invoices) && <Route path="/invoice/:id/edit" component={EditInvoice} />}
        </Switch>
    )
}
